import React, { useState } from 'react';
import { AgendaSlotList } from './AgendaSlotList';
import { AgendaTabs } from './AgendaTabs';
import { Tab } from './types';

import { DEFAULT_MAX_SLOTS } from '../../../Agenda/constants';
import styles from './AgendaView.module.scss';

interface AgendaViewProps {
    tabs: Tab[];
    maxSlots?: number;
    onActiveTabChange?: (tab: Tab) => void;
}

export const AgendaView = ({
    tabs,
    maxSlots = DEFAULT_MAX_SLOTS,
    onActiveTabChange,
}: AgendaViewProps) => {
    const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);

    const handleTabClick = (tab: Tab) => {
        setActiveTab(tab);
        onActiveTabChange && onActiveTabChange(tab);
    };

    return (
        <div className={styles.agendaView}>
            <AgendaTabs tabs={tabs} onTabClick={handleTabClick} />
            <AgendaSlotList
                slots={activeTab.slots}
                maxSlots={maxSlots}
                keyFactory={(slot) =>
                    `${activeTab.name}-${slot.title}-${slot.startTime}-${slot.endTime}`
                }
            />
        </div>
    );
};
